import React from 'react';
import cx from 'classnames';
import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';

import Button from '@material-ui/core/Button';

export const OpeningHourHistoryDetails = ({ details, setSelected }) => (
  <div className="w-full h-full">
    <Button
      size="small"
      variant="outlined"
      color="primary"
      style={{ position: 'absolute', right: '1rem' }}
      onClick={() => setSelected(null)}>
      Back to list
    </Button>
    <table className="text-left w-full h-full border-collapse bg-white table-fixed">
      <thead>
        <tr className="b-2-white">
          <th className="p-2 font-normal w-32">Updated By</th>
          <th className="p-2 font-normal w-32">Updated On</th>
          <th className="p-2 font-normal">Opening Hour</th>
        </tr>
      </thead>
      <tbody>
        <tr
          key={details.id}
          className={cx('b-2-white', {
            'bg-lightYellow': details.operation_type === 'UPDATE',
            'bg-lightGreen': details.operation_type === 'CREATE',
            'bg-lightRed': details.operation_type === 'DELETE',
          })}>
          <td className="p-2">{details.modified_by}</td>
          <td className="p-2">
            {format(parseISO(details.modified_at), 'd MMM yyyy')}
          </td>
          <td className="p-2 text-sm">
            <div>Name: {details.name}</div>
            <div className="flex justify-between mt-2">
              <div>Timezone: {details.time_zone}</div>
              <div>Type: {details.type}</div>
            </div>
            <table className="time_bracket_table mt-4 w-full border-collapse">
              <thead>
                <tr>
                  <th> </th>
                  <th>From</th>
                  <th>To</th>
                </tr>
              </thead>
              <tbody>
                {details.opening_hour_times.map((day) => (
                  <tr key={day.id}>
                    <td>{day.weekday}</td>
                    <td>{day.opening_time}</td>
                    <td>{day.closing_time}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
);
